import React from 'react'

import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled'
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled'
import { IconButton } from '@mui/material'

import { campaignTargetActionButton } from '@albacross/frontend-utils'

// isActive + onClick are injected by the HOC, so callers pass only ActionButtonProps — keep them optional here.
type CampaignTargetActionButtonProps = {
  isActive?: boolean
  onClick?: (...args: any[]) => any
}

const CampaignTargetActionButton = ({ isActive, onClick }: CampaignTargetActionButtonProps) => (
  <IconButton
    aria-label={isActive ? 'Pause' : 'Resume'}
    color={isActive ? 'primary' : 'secondary'}
    onClick={onClick}
    size="large">
    {isActive ? <PauseCircleFilledIcon /> : <PlayCircleFilledIcon />}
  </IconButton>
)

export default campaignTargetActionButton(CampaignTargetActionButton)
